<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/PUU8eB/tc-custom/9781504090001.jpg?1707968122736" alt="This image is the cover for the book Treachery of Friends"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Treachery of Friends
      </h1>
      <p class="bookDescription body article font2">
        <b>From the Dagger Award–winning “top notch thriller writer,” a new novel of politics, religion, power, and a woman’s search for her missing father’s secrets (Simon Kernick, bestselling author of <i>Relentless</i>).</b><br/><br/> A man lies bleeding on the roadside. Hidden in his clothing is a message to Sidney from her father—who has been missing for fourteen years . . .<br/><br/> Practical and level-headed Sid doesn’t believe in miracles. So she sets out on a search for her father that leads to his old friends from university—or at least, the two of them who are still around. One is the head of a religious cult. The other is an ambitious politician. And both have secrets they want to stay buried—secrets Sid will have to uncover before a killer strikes again . . .<br/><br/><b>Praise for CJ Carver</b><br/><br/> “A page-turning must read.” —<i>Booklist</i><br/><br/> “Solid gold.” —Lee Child, #1 <i>New York Times</i>–bestselling author of the Jack Reacher series<br/>  <br/> “Exceptional.” —<i>Publishers Weekly</i> (starred review)
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        CJ Carver
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Bloodhound Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?d22efc02